'use client'
import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps,PrismicRichText } from "@prismicio/react";
import Slider from "react-slick";

/**
 * Props for `TestimonialsSlider`.
 */
export type TestimonialsSliderProps =
  SliceComponentProps<Content.TestimonialsSliderSlice>;

/**
 * Component for "TestimonialsSlider" Slices.
 */
const TestimonialsSlider: FC<TestimonialsSliderProps> = ({ slice }) => {

  const settings = {
    autoplay: true,
    dots: false,
    infinite: true,
    speed: 2000,
    autoPlaySpeed:5000,
    adaptiveHeight: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024, // Tablet Vertical (<=1024px)
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768, // Mobile (<=768px)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="w-screen py-12 font-fellix"
    >
      <div className="inner-wrapper">
        <article className="text-center pb-12">
          <PrismicRichText field={slice.primary?.heading}/>
          <PrismicRichText field={slice.primary?.description}/>
        </article>
        <Slider {...settings} className="testimonials">
          {slice.primary.testimonials.map((item, index) => {
            const background =
              index % 2
                ? "bg-orange text-white"
                : index % 5
                ? "bg-jade text-white"
                : "bg-jade/10 text-jade";

            return (
              <div
                key={index}
                className={
                  background +
                  " p-8 lg:p-[3dvw] h-[300px] md:h-[30dvw] lg:h-[45dvw] 2xl:max-h-[400px]"
                }
              >
                <div className="flex items-center">
                  <article className="font-semibold text-[18px] leading-[24px] md:text-[20px] md:leading-[28px] lg:text-[26px] lg:leading-[30px]">
                    <PrismicRichText field={item.quote} />
                  </article>
                  <article className="text-[14px] leading-[18px]">
                    <PrismicRichText field={item.by_line} />
                  </article>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </section>
  );
};

export default TestimonialsSlider;

